export default __webpack_public_path__ + "static/media/certificate.3fc5720a.svg";